export const types = [
  {
    id: 1,
    label: 'Defaults',
    value: 'Defaults',
  },
  {
    id: 2,
    label: 'Flowers',
    value: 'Flowers',
  },
  {
    id: 3,
    label: 'Pre-Rolls',
    value: 'Pre-Rolls',
  },
  {
    id: 4,
    label: 'Vapable',
    value: 'Vapable',
  },
  {
    id: 5,
    label: 'Concentrates',
    value: 'Concentrates',
  },
  {
    id: 6,
    label: 'Beverages',
    value: 'Beverages',
  },
  {
    id: 7,
    label: 'Edibles',
    value: 'Edibles',
  },
  {
    id: 8,
    label: 'Oils',
    value: 'Oils',
  },
  {
    id: 9,
    label: 'Topicals',
    value: 'Topicals',
  },
  {
    id: 12,
    label: 'Seeds',
    value: 'Seeds',
  },
  {
    id: 14,
    label: 'Producers',
    value: 'Producers',
  },
];

export const qualities = [
  {
    id: 0,
    label: 'undefined',
    value: 'undefined',
  },
  {
    id: 1,
    label: 1,
    value: 1,
  }, {
    id: 2,
    label: 2,
    value: 2,
  }, {
    id: 3,
    label: 3,
    value: 3,
  }, {
    id: 4,
    label: 4,
    value: 4,
  }, {
    id: 5,
    label: 5,
    value: 5,
  }];

export const tarpenes = [
  {
    id: 0,
    label: 'undefined',
    value: 'undefined',
  },
  {
    id: 1,
    label: 'Myrcene',
    value: 'Myrcene',
  }, {
    id: 2,
    label: 'Pinene',
    value: 'Pinene',
  }, {
    id: 3,
    label: 'Limonene',
    value: 'Limonene',
  }, {
    id: 4,
    label: 'Caryophyllene',
    value: 'Caryophyllene',
  }, {
    id: 5,
    label: 'Linalool',
    value: 'Linalool',
  },
  {
    id: 6,
    label: 'Terpinolene',
    value: 'Terpinolene',
  }, {
    id: 7,
    label: 'Bisabolol',
    value: 'Bisabolol',
  }, {
    id: 8,
    label: 'Ocimene',
    value: 'Ocimene',
  }, {
    id: 9,
    label: 'Nerolidol',
    value: 'Nerolidol',
  },
  {
    id: 10,
    label: 'Humulene',
    value: 'Humulene',
  }, {
    id: 11,
    label: 'Guaiol',
    value: 'Guaiol',
  },
];

export const effects = [
  {
    id: 0,
    label: 'undefined',
    value: 'undefined',
  },
  {
    id: 1,
    label: 'Excite',
    value: 'Excite',
  }, {
    id: 2,
    label: 'Energize',
    value: 'Energize',
  }, {
    id: 3,
    label: 'Mellow',
    value: 'Mellow',
  }, {
    id: 4,
    label: 'Relax',
    value: 'Relax',
  }, {
    id: 5,
    label: 'Socialize',
    value: 'Socialize',
  },
  {
    id: 6,
    label: 'Motivate',
    value: 'Motivate',
  },
];

export const formatFlower = [
  {
    id: 0,
    label: 'undefined',
    value: 'undefined',
  },
  {
    id: 1,
    label: 'Parent',
    value: 'Parent',
  }, {
    id: 2,
    label: '1g',
    value: '1g',
  }, {
    id: 3,
    label: '3.5g',
    value: '3.5g',
  }, {
    id: 4,
    label: '5g',
    value: '5g',
  }, {
    id: 5,
    label: '7g',
    value: '7g',
  },
  {
    id: 6,
    label: '14g',
    value: '14g',
  },
  {
    id: 7,
    label: '15g',
    value: '15g',
  },
  {
    id: 8,
    label: '28g',
    value: '28g',
  },
  {
    id: 9,
    label: '29g',
    value: '29g',
  },
  {
    id: 10,
    label: '30g',
    value: '30g',
  },
];

export const formataPreroll = [
  {
    id: 0,
    label: 'undefined',
    value: 'undefined',
  },
  {
    id: 1,
    label: 'Parent',
    value: 'Parent',
  }, {
    id: 2,
    label: '3 x 0.3g',
    value: '3 x 0.3g',
  }, {
    id: 3,
    label: '1 x 0.5g',
    value: '1 x 0.5g',
  }, {
    id: 4,
    label: '2 x 0.5g',
    value: '2 x 0.5g',
  }, {
    id: 5,
    label: '3 x 0.5g',
    value: '3 x 0.5g',
  },
  {
    id: 6,
    label: '4 x 0.5g',
    value: '4 x 0.5g',
  },
  {
    id: 7,
    label: '5 x 0.5g',
    value: '5 x 0.5g',
  },
  {
    id: 8,
    label: '7 x 0.5g',
    value: '7 x 0.5g',
  },
  {
    id: 9,
    label: '8 x 0.5g',
    value: '8 x 0.5g',
  },
  {
    id: 10,
    label: '10 x 0.5g',
    value: '10 x 0.5g',
  },
  {
    id: 11,
    label: '1 x 0.7g',
    value: '1 x 0.7g',
  },
  {
    id: 12,
    label: '3 x 0.75g',
    value: '3 x 0.75g',
  },
  {
    id: 13,
    label: '1 x 1g',
    value: '1 x 1g',
  },
  {
    id: 14,
    label: '2 x 1g',
    value: '2 x 1g',
  },
];

export const formatConcentrates = [
  'Parent',
  '0.25g',
  '0.5g',
  '1g',
  '2g',
];

export const typesConcentrates = [
  'Badder',
  'Bubble Hash',
  'Distillate',
  'Hash',
  'Hash Rosin',
  'Kief',
  'Live Hash',
  'Live Resin Hash',
  'Live Rosin',
  'Mountain Bubble Hash',
  'Rosin',
  'Shatter',
];

export const formatVapableConcentrates = [
  {
    id: 1,
    label: 'Parent',
    value: 'Parent',
  }, {
    id: 2,
    label: '0.15g',
    value: '0.15g',
  }, {
    id: 3,
    label: '0.25g',
    value: '0.25g',
  }, {
    id: 4,
    label: '0.3g',
    value: '0.3g',
  }, {
    id: 5,
    label: '0.35g',
    value: '0.35g',
  },
  {
    id: 6,
    label: '0.42g',
    value: '0.42g',
  },
  {
    id: 7,
    label: '0.5g',
    value: '0.5g',
  },
  {
    id: 8,
    label: '1g',
    value: '1g',
  },
  {
    id: 9,
    label: '50 Doses',
    value: '50 Doses',
  },
  {
    id: 10,
    label: '200 Doses',
    value: '200 Doses',
  },
];

export const typesVapableConcentrates = [
  {
    id: 0,
    label: 'undefined',
    value: 'undefined',
  },
  {
    id: 1,
    label: '510 Thread',
    value: '510 Thread',
  }, {
    id: 2,
    label: 'PAX Pod',
    value: 'PAX Pod',
  }, {
    id: 3,
    label: 'Disposable',
    value: 'Disposable',
  },
];

export const formataEdibles = [
  'Parent',
  '1 x 10mg',
  '2 x 5mg',
  '4 x 2.5mg',
  '5 x 2mg',
  '2 x 10mg',
  '5 x 10mg',
];

export const typesEdibles = [
  'Gummy',
  'Chocolate',
  'Cookie',
  'Mint',
];

export const formatOil = [
  'Parent',
  'x15',
  'x20',
  'x25',
  'x30',
  'x40',
  'x60',
  '15ml',
  '16ml',
  '20ml',
  '25ml',
  '30ml',
  '40ml',
];

export const provinces = [
  {
    id: 0,
    label: 'undefined',
    value: 'undefined',
  },
  {
    id: 1,
    label: 'Alberta',
    value: 'Alberta',
  }, {
    id: 2,
    label: 'British Columbia',
    value: 'British Columbia',
  }, {
    id: 3,
    label: 'Manitoba',
    value: 'Manitoba',
  }, {
    id: 4,
    label: 'New Brunswick',
    value: 'New Brunswick',
  }, {
    id: 5,
    label: 'Nefoundland and Labrador',
    value: 'Nefoundland and Labrador',
  },
  {
    id: 6,
    label: 'Northwest Territories',
    value: 'Northwest Territories',
  },
  {
    id: 7,
    label: 'Nova Scotia',
    value: 'Nova Scotia',
  },
  {
    id: 8,
    label: 'Nunavut',
    value: 'Nunavut',
  },
  {
    id: 9,
    label: 'Prince Edward Island',
    value: 'Prince Edward Island',
  },
  {
    id: 10,
    label: 'Quebec',
    value: 'Quebec',
  },
  {
    id: 11,
    label: 'Saskatchewan',
    value: 'Saskatchewan',
  },
  {
    id: 12,
    label: 'Yukon',
    value: 'Yukon',
  },
];

export const categories = [
  {
    id: 0,
    label: 'undefined',
    value: 'undefined',
  },
  {
    id: 1,
    label: 'THC Flower',
    value: 'THC Flower',
  }, {
    id: 2,
    label: 'CBD Flower',
    value: 'CBD Flower',
  }, {
    id: 3,
    label: 'THC Pre-Rolls',
    value: 'THC Pre-Rolls',
  }, {
    id: 4,
    label: 'CBD Pre-Rolls',
    value: 'CBD Pre-Rolls',
  }, {
    id: 5,
    label: 'Vapable Concentrates',
    value: 'Vapable Concentrates',
  },
  {
    id: 6,
    label: 'Concentrates',
    value: 'Concentrates',
  },
  {
    id: 7,
    label: 'Beverages',
    value: 'Beverages',
  },
  {
    id: 8,
    label: 'Edibles',
    value: 'Edibles',
  },
  {
    id: 9,
    label: 'Oils / Soft Gels',
    value: 'Oils / Soft Gels',
  },
  {
    id: 10,
    label: 'Topicals',
    value: 'Topicals',
  },
  {
    id: 11,
    label: 'Seeds',
    value: 'Seeds',
  },
];

export const phenoTypes = [
  {
    id: 0,
    label: 'undefined',
    value: 'undefined',
  },
  {
    id: 1,
    label: 'Sativa',
    value: 'Sativa',
  },
  {
    id: 2,
    label: 'Indica',
    value: 'Indica',
  },
  {
    id: 3,
    label: 'Hybrid',
    value: 'Hybrid',
  },
];

export const yesNo = [
  {
    id: 0,
    label: 'undefined',
    value: 'undefined',
  },
  {
    id: 1,
    label: 'yes',
    value: 'yes',
  },
  {
    id: 2,
    label: 'no',
    value: 'no',
  },
];
